import { ShieldCheck } from "lucide-react";

const FOOD_SAFETY_STATUSES = new Set(["delivering", "delivered", "ready", "completed"]);

export default function FoodSafetyNotice({ status, isDelivery, isPickup, brandColor = "#059669" }) {
  if (!isDelivery && !isPickup) return null;
  if (!FOOD_SAFETY_STATUSES.has(status)) return null;
  if (isPickup && status === "delivering") return null;

  return (
    <div
      data-testid="food-safety-notice"
      style={{
        background: "linear-gradient(135deg, #fffbf2 0%, #fefce8 100%)",
        border: "1px solid #fde68a",
        borderLeft: `3px solid ${brandColor}`,
        borderRadius: "14px",
        padding: "18px 20px",
        fontFamily: "inherit",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
        <ShieldCheck style={{ width: "16px", height: "16px", color: brandColor, flexShrink: 0 }} />
        <span style={{ fontSize: "10px", fontWeight: "800", letterSpacing: "0.1em", textTransform: "uppercase", color: brandColor }}>
          Seguridad Alimentaria
        </span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "7px" }}>
        <p style={{ margin: 0, fontSize: "11.5px", lineHeight: "1.6", color: "#78350f", fontWeight: "500" }}>
          Para garantizar la máxima calidad y seguridad alimentaria, recomendamos el
          consumo <strong>inmediato</strong> de nuestros productos.
        </p>
        <p style={{ margin: 0, fontSize: "11px", lineHeight: "1.6", color: "#92400e" }}>
          Nuestros elaborados contienen ingredientes frescos y manipulados, especialmente
          pescado crudo, por lo que <strong>no se aconseja su conservación prolongada</strong>.
        </p>
        <p style={{ margin: 0, fontSize: "11px", lineHeight: "1.6", color: "#92400e" }}>
          En caso de no consumir de inmediato, mantener refrigerado entre{" "}
          <strong>2 °C y 4 °C</strong> y consumir en el menor tiempo posible.
        </p>
        <div style={{ marginTop: "6px", paddingTop: "8px", borderTop: "1px solid #fde68a" }}>
          <p style={{ margin: 0, fontSize: "10px", lineHeight: "1.5", color: "#a16207", fontStyle: "italic" }}>
            El establecimiento no se responsabiliza del estado del producto una vez
            finalizada la entrega si no se respetan las condiciones de conservación indicadas.
          </p>
        </div>
      </div>
    </div>
  );
}
